module.exports = __webpack_public_path__ + "img/03a06c4.jpg";